import React, { FC, useEffect } from 'react';

import { ITimelineItemSliderButton } from './interfaces';

import './styles.scss';
import SliderArrow from '../../../../../assets/icons/slider-arrow';

// time line item slider button
const TimelineItemSliderButton: FC<ITimelineItemSliderButton> = ({
  type,
  onClick,
  current = 0,
  count = 0
}) => {

  useEffect(() => {
    const calculatePosition = () => {
      const buttons = document.querySelectorAll('.time-line-item-slider-button');
  
      buttons.forEach((button: any) => {
        const container = button.closest(".time-line-item-slider-container");
        const items = container.querySelectorAll(".time-line-item-slider-item");
  
        items.forEach((item: any) => {
          if (item.getAttribute("data-active") === "true") {
            const title = item.querySelector(".paragraph.title");
            
            const titleHeight = title.getBoundingClientRect().height;
  
            if (button.classList.contains('prev')) {
              button.style.top = `calc(${titleHeight}px + 73px)`;
            }
            else {
              button.style.top = `calc(${titleHeight}px + 19px)`;
            }
          }
        });
      });
    }

    calculatePosition()
  })

  return (
    <button
      className={`btn time-line-item-slider-button ${type}`}
      data-disabled={type === 'prev'
        ? current <= 0 : current >= (count - 1) || !onClick}
      onClick={onClick}>
      <SliderArrow />
    </button>
  );
};

export default TimelineItemSliderButton;